export const AppConstants = {
  USER_TOKEN_KEY: 'user_token',
  APP_CONTEXT_KEY: 'app_context',

  GENDERS: {
    Male: 38,
    Female: 39,
    'Non-binary': 40,
    'Prefer not to say': 41,
  },

  CONTACT_TYPE_LIST: [
    { Id: 1, Name: 'Mobile' },
    { Id: 2, Name: 'Home' },
    { Id: 3, Name: 'Work' },
  ],

  ADDRESS_TYPE_LIST: [
    { Id: 51, Name: 'Physical' },
    { Id: 53, Name: 'Home' },
    { Id: 54, Name: 'Office' },
    { Id: 55, Name: 'Other' },
  ],

  STATE_LIST: [
    { Id: 1, Name: 'Australian Capital Territory', ShortName: 'ACT' },
    { Id: 2, Name: 'New South Wales', ShortName: 'NSW' },
    { Id: 3, Name: 'Northern Territory', ShortName: 'NT' },
    { Id: 4, Name: 'Queensland', ShortName: 'QLD' },
    { Id: 5, Name: 'South Australia', ShortName: 'SA' },
    { Id: 6, Name: 'Tasmania', ShortName: 'TAS' },
    { Id: 7, Name: 'Victoria', ShortName: 'VIC' },
    { Id: 8, Name: 'Western Australia', ShortName: 'WA' },
  ],

  TITLE_LIST: [
    { Id: 1, Name: 'Mr' },
    { Id: 2, Name: 'Mrs' },
    { Id: 3, Name: 'Ms' },
    { Id: 4, Name: 'Miss' },
    { Id: 5, Name: 'Dr' },
    { Id: 6, Name: 'Mx' },
  ],

  NAME_TYPE_LIST: [
    { Id: 1, Name: 'Middle Name' },
    { Id: 2, Name: 'Preferred Name' },
    { Id: 3, Name: 'Nee' },
    { Id: 4, Name: 'Other Name' },
  ],

  INDIGENOUS_STATUS_LIST: [
    { Id: 1, Name: 'Aboriginal' },
    { Id: 2, Name: 'Torres Strait Islander' },
    { Id: 3, Name: 'Both Aboriginal and Torres Strait Islander' },
  ],

  RELATIONSHIP_TYPE_LIST: [
    { Id: 1, Name: 'Parent' },
    { Id: 2, Name: 'Spouse' },
    { Id: 3, Name: 'Sibling' },
    { Id: 4, Name: 'Child' },
    { Id: 5, Name: 'Friend' },
    { Id: 6, Name: 'Other' },
  ],
  RELATIONSHIP_OTHER_ID: 6,

  FEATURE_FLAGS: {
    ENABLE_LOGIN: 'EnableLogin',
    ONLINE_BOOKING: 'OnlineBooking',
  },
};
